// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingList_spinner__AvIsu","spinnyBoi":"LoadingList_spinnyBoi__p95My"};